import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import LandingPage from './pages/LandingPage'
import NotFound from './pages/NotFound'
import LoadingSpinner from './components/LoadingSpinner'

const ModelGallery = lazy(() => import('./pages/ModelGallery'))
const ModelViewer = lazy(() => import('./pages/ModelViewer'))

export default function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/case/:caseId" element={<ModelGallery />} />
          <Route path="/view/:caseId/:modelId" element={<ModelViewer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}
